// extracted by mini-css-extract-plugin
module.exports = {"container":"bL","title":"bM","text":"bN"};